import { IDeal } from '@interfaces/deal';

export const calcDealRealizedPnl = (deal: IDeal, isPnlWithFee: boolean) => {
  return isPnlWithFee ? parseFloat(deal.realizedPnl) + parseFloat(deal.totalFee) : deal.realizedPnl;
};
